import React, { Fragment, useState, useEffect } from "react";
import { Container, Row, Col, Card, Modal, Spinner } from 'react-bootstrap';
import Navbar from "../../components/Navbar";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import Logo from "../../images/logo2.png"; // Assuming this path is correct
import PageTitle from "../../components/pagetitle/PageTitle";

// Import images
import Fimg1 from "../../images/flora/1-min.png";
import Fimg2 from "../../images/flora/2-min.png";
import Fimg3 from "../../images/flora/3-min.png";
import Fimg4 from "../../images/flora/4-min.png";
import Fimg5 from "../../images/flora/5-min.png";
import Fimg6 from "../../images/flora/6-min.png";
import Fimg7 from "../../images/flora/7-min.png";
import Fimg8 from "../../images/flora/8-min.png";
import Fimg9 from "../../images/flora/9-min.png";
import Fimg10 from "../../images/flora/10-min.png";
import Fimg11 from "../../images/flora/11-min.png";
import Fimg12 from "../../images/flora/12-min.png";
import Fimg13 from "../../images/flora/13-min.png";

// It's good practice to add CSS imports if you have a dedicated CSS file.
// For example: import './FloraPage.css'; 
// The necessary CSS is provided below this code block.

const floraImages = [
  { id: 1, src: Fimg1, alt: "Flora Image 1" },
  { id: 2, src: Fimg2, alt: "Flora Image 2" },
  { id: 3, src: Fimg3, alt: "Flora Image 3" },
  { id: 4, src: Fimg4, alt: "Flora Image 4" },
  { id: 5, src: Fimg5, alt: "Flora Image 5" },
  { id: 6, src: Fimg6, alt: "Flora Image 6" },
  { id: 7, src: Fimg7, alt: "Flora Image 7" },
  { id: 8, src: Fimg8, alt: "Flora Image 8" },
  { id: 9, src: Fimg9, alt: "Flora Image 9" },
  { id: 10, src: Fimg10, alt: "Flora Image 10" },
  { id: 11, src: Fimg11, alt: "Flora Image 11" },
  { id: 12, src: Fimg12, alt: "Flora Image 12" },
  { id: 13, src: Fimg13, alt: "Flora Image 13" },
];

const FloraPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadImages = async () => {
      try {
        await new Promise(resolve => setTimeout(resolve, 800));
        setIsLoading(false);
      } catch (error) {
        console.error("Error during initial loading:", error);
        setIsLoading(false);
      }
    };

    loadImages();
  }, []);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    // selectedImage will be cleared by onExited prop of Modal
  };

  return (
    <Fragment>
      <Navbar hclass={"wpo-header-style-3"} Logo={Logo} />
      <PageTitle pageTitle={"Explore Flora Around Us"} pagesub={"Review"} />

      <Container className="my-5">
        {isLoading ? (
          <div className="text-center py-5">
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <p className="mt-3">Loading beautiful flora...</p>
          </div>
        ) : (
          <Row>
            {floraImages.map((image) => (
              <Col xs={12} sm={6} md={4} key={image.id} className="mb-4">
                <Card onClick={() => handleImageClick(image)} style={{ cursor: "pointer" }}>
                  <Card.Img variant="top" src={image.src} alt={image.alt} />
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Container>

      {selectedImage && (
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          onExited={() => setSelectedImage(null)} // Clear image after modal has fully closed
          size="lg" // Changed to 'lg' for better image viewing, can be 'md'
          centered
          contentClassName="custom-modal-content-for-close-btn" // For positioning context
        >
          <Modal.Header /* No closeButton prop here */ >
            <Modal.Title>{selectedImage.alt}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <img
              src={selectedImage.src}
              alt={`Enlarged ${selectedImage.alt}`}
              className="img-fluid"
            />
          </Modal.Body>
          {/* Custom Close Button */}
          <button
            type="button"
            className="btn-close custom-modal-middle-right-close"
            onClick={handleCloseModal}
            aria-label="Close"
          ></button>
        </Modal>
      )}
      <Scrollbar />
      <Footer />
    </Fragment>
  );
};

export default FloraPage;